import axios from "@/plugins/axios";

let url = "/api/v1/gshop2/setting";

export const setting = {
    get(){
        return axios.get(`${url}`).then(result => result.data);
    },
}